import httpApiApplication from 'app/http/httpApiApplication';

import { type ReportPeriodicity } from '../components/ReportPeriodicity/types';
import { type Report } from '../models/types';

export const BaseUrlReports = '/reports';
export const BaseUrlReportPeriodicity = '/ReportPeriodicity';

export function updateReport(id: string, report: Report) {
  return httpApiApplication.put(`${BaseUrlReports}/${id}`, report);
}

export function deleteReport(id: string) {
  return httpApiApplication.delete(`${BaseUrlReports}/${id}`);
}

export const createReport = (report: Report) => {
  return httpApiApplication.post(BaseUrlReports, report);
};

export function updateReportPeriodicity(
  reportId: string,
  id: string,
  reportPeriodicity: ReportPeriodicity
) {
  return httpApiApplication.put(
    `${BaseUrlReports}/${reportId}${BaseUrlReportPeriodicity}/${id}`,
    reportPeriodicity
  );
}

export function deleteReportPeriodicity(reportId: string, id: string) {
  return httpApiApplication.delete(
    `${BaseUrlReports}/${reportId}${BaseUrlReportPeriodicity}/${id}`
  );
}

export const createReportPeriodicity = (reportId: string, reportPeriodicity: ReportPeriodicity) => {
  return httpApiApplication.post(
    `${BaseUrlReports}/${reportId}${BaseUrlReportPeriodicity}`,
    reportPeriodicity
  );
};
